/* libs/oyan-ui/src/lib/components/cards/components/threshold-card/threshold-card.component.scss */
/*# sourceMappingURL=threshold-card.component.css.map */
